import { JsToClientCommand } from '../jsToClientCommand';
import { ClientCommands } from '../clientCommands';

export class SetMaintenanceDataCommand extends JsToClientCommand<{}> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(params: {[key:string]: any}) {
        super(ClientCommands.SET_MAINTENANCE_DATA, params);
    }
}
